// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--hqR5r","link":"_6c97079b1b--link--vreZ4"};